/**
 * Flattens one `validation_errors` value from the API into readable messages.
 * DRF nests errors for list and nested fields: `[{}, {num: ["..."]}]` before 3.18, and `{"1": {num: ["..."]}}`
 * from 3.18 on (also `ListField`/`DictField` always). Index keys are dropped; field names prefix their messages.
 */
const INDEX_KEY = /^\d+$/;
export function validationErrorMessages(value) {
    if (value === null || value === undefined)
        return [];
    if (Array.isArray(value))
        return value.flatMap(validationErrorMessages);
    if (typeof value !== "object")
        return [String(value)];
    return Object.entries(value).flatMap(([key, nested]) => {
        const messages = validationErrorMessages(nested);
        return INDEX_KEY.test(key) ? messages : messages.map((message) => `${key.replace(/_/g, " ")}: ${message}`);
    });
}
